<template>
  <v-app>
    <v-navigation-drawer
      v-if="!$route.meta.plainLayout"
      v-model="drawer"
      mini-variant-width="45"
      :mini-variant="mini"
      permanent
      clipped
      app
    >
      <sideBarNav
        class="pt-1"
        :mini="mini"
        :side_bar_items_config="side_bar_nav_config"
        :selected_item="selected_item"
      />
    </v-navigation-drawer>

    <v-app-bar
      :key="navBarKey"
      color="crawloOrange"
      dark
      dense
      clipped-left
      app
      v-if="!$route.meta.plainLayout"
      class="mainNavBar"
    >
      <v-app-bar-nav-icon @click.stop="mini = !mini">
        <v-icon v-if="!mini">$arrow_left</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <router-link to="pricing" class="d-flex align-center pa-3">
          <img :src="require('./assets/Dynamic_Pricing.svg')" width="180" />
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Plan Badge -->
      <!--<v-chip
        v-if="currentPlan"
        color="transparent"
        text-color="white"
        outlined
        small
        class="mr-3 plan-badge"
      >
        {{ currentPlan }} Plan
      </v-chip>-->

      <span v-if="account != '654b792b2071861acbbc3331'">
        {{ user_website.id == source_id ? 'Xiaomi' : website_alias }}
      </span>
      <img
        v-if="account != '654b792b2071861acbbc3331'"
        :src="faviconSrc"
        @error="handleFaviconError"
        :alt="faviconAlt"
        :website="user_website.id == source_id ? 'www.mi.com' : website_url"
        width="20"
        class="ml-2 mr-4 favicon-img"
        ref="myImg"
      />

      <v-menu :close-on-content-click="false" :nudge-width="350" max-width="350" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on">
            <v-badge
              color="success"
              :content="notification_count"
              :value="notification_count > 0"
              overlap
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-card max-height="500">
          <v-list v-if="notifications.unseen.length">
            <v-subheader>Unseen</v-subheader>
            <template v-for="(item, index) in notifications.unseen">
              <v-list-item v-bind:key="index" @click="showNotificationModal(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle
                    >{{ item.product_type }} - {{ item.time }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click.stop="deleteNotification(item)" icon>
                    <v-icon color="grey">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>

          <v-divider class="ma-0" v-if="notifications.unseen.length"></v-divider>

          <v-list>
            <v-subheader
              >Seen
              <v-btn
                class="ml-auto"
                color="primary"
                text
                @click="deleteSeenNotification()"
                v-if="notifications.seen.length"
                >Delete all</v-btn
              ></v-subheader
            >
            <v-list-item v-if="!notifications.seen.length">
              <v-list-item-content class="pt-0 pb-2">
                <v-list-item-subtitle class="text-center"
                  >There is no notification</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <template v-for="(item, index) in notifications.seen">
              <v-list-item v-bind:key="index" @click="showNotificationModal(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle
                    >{{ item.product_type }} - {{ item.time }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click.stop="deleteNotification(item)" icon>
                    <v-icon color="grey">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-menu>
      <v-menu :close-on-content-click="false" :nudge-width="250" max-width="250" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar :color="website_color">
                <span class="white--text md-text font-weight-bold">{{ avatar_text }}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ fullname }}</v-list-item-title>
                <v-list-item-subtitle>{{ username }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="ma-0"></v-divider>

          <v-list>
            <template v-for="item in nav_bar_config.drop_down_items">
              <template
                v-if="item.admin_only == undefined || (item.admin_only && super_admin == 'true')"
              >
                <v-divider v-if="item.upper_divider" :key="item.name" :inset="true"></v-divider>
                <v-list-item
                  v-if="item.route && !item.child_routes"
                  @click="redirectTo(item.route)"
                  :key="item.name"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" :color="item.icon_color"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.callback" @click="item.callback" :key="item.name">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" :color="item.icon_color"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>

                <v-list-group
                  v-if="item.child_routes"
                  :key="item.name"
                  :prepend-icon="item.icon"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item v-for="child in item.child_routes" :key="child.name">
                    <v-list-item-content>
                      <v-list-item-title v-text="child.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </template>
            </template>
            <v-divider></v-divider>
            <v-list-item @click="signOut()">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="ml-3">
            <country-flag
              :country="selected_account.region"
              size="normal"
              v-bind="attrs"
              v-on="on"
              :rounded="true"
            />
          </div>
        </template>
        <v-list dense>
          <v-list-item
            v-for="account in associated_accounts.filter(
              (account) => account.id !== selected_account.id,
            )"
            v-bind:key="account.id"
            @click="select_account(account)"
          >
            <v-list-item-icon class="mr-1">
              <div>
                <country-flag :country="account.region" size="small" :rounded="true" />
              </div>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="account.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main class="content-background">
      <v-container class="pa-3" fluid>
        <router-view default="/Pricing"></router-view>
      </v-container>
    </v-main>
    <notificationModal :show="show_notification" :item="selected_notification" />
    <snackbar :show="snackbar" :color="snackbar_color" :msg="snackbar_msg" :icon="snackbar_icon" />

    <!-- New Version Available Dialog -->
    <v-dialog v-model="showRefreshDialog" persistent max-width="440" content-class="version-dialog">
      <v-card class="version-dialog-card" rounded="lg" elevation="8">
        <!-- Accent strip -->
        <div class="version-accent-strip"></div>

        <div class="text-center pt-6 pb-2">
          <div class="version-icon-wrapper mx-auto mb-3">
            <v-icon size="32" color="white">mdi-rocket-launch-outline</v-icon>
          </div>
          <div class="text-h6 font-weight-bold" style="color: #2d3436">New Version Available</div>
          <p class="text-body-2 grey--text text--darken-1 mt-1 mb-0 px-6">
            We've shipped improvements and new features.
          </p>
        </div>

        <v-card-text class="px-6 pt-3 pb-1">
          <div class="version-info-box d-flex align-center pa-3 rounded-lg">
            <v-icon size="18" color="#FF8C00" class="mr-2">mdi-information-outline</v-icon>
            <span class="text-caption" style="color: #636e72; line-height: 1.4">
              Refresh to get the latest updates. Your current work won't be lost.
            </span>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-5 pt-3">
          <v-btn
            text
            small
            color="grey"
            class="text-none font-weight-medium"
            @click="dismissRefreshDialog"
          >
            Later
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#FF8C00"
            dark
            depressed
            rounded
            class="text-none font-weight-bold px-5"
            @click="refreshPage"
          >
            <v-icon left small>mdi-refresh</v-icon>
            Refresh Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import axios from 'axios'
  import sideBarNav from './modules/sidebarnav.vue'
  import io from 'socket.io-client'
  import notificationModal from './components/common/notificationModal.vue'

  export default {
    components: {
      notificationModal,
      sideBarNav,
    },
    data: () => ({
      navBarKey: 0,
      account: localStorage.account_id,
      user_website: localStorage.user_website ? JSON.parse(localStorage.user_website) : {},
      associated_accounts: [],
      selected_account: {
        region: '',
        name: 'Current Account',
      },
      source_id: '6019aee744817b0f85ff85bb',
      currentPlan: null,
      snackbar: false,
      snackbar_msg: '',
      snackbar_color: '',
      snackbar_icon: '',
      // Version check properties
      showRefreshDialog: false,
      versionCheckInterval: null,
      currentBuildHash: process.env.VUE_APP_BUILD_HASH || null,
      selected_item: '/pricing',
      show_notification: false,
      selected_notification: '',
      super_admin: localStorage.getItem('super_admin'),
      fullname: localStorage.getItem('fullname'),
      username: localStorage.getItem('user'),
      website_alias: localStorage.getItem('website_alias'),
      website_url: localStorage.getItem('website_url'),
      website_color: localStorage.getItem('website_color'),
      notifications: { unseen: [], seen: [] },
      notification_count: 0,
      mini: true,
      drawer: true,
      socketConnected: false,
      socket_connected: false,
      gotoPage: '',
      nav_bar_config: {
        routes: [],
        toggle_target: 'sidebar',
        toggle_target_mobile: 'offcanvas-push',
        drop_down_items: [
          {
            name: 'Settings',
            icon: 'mdi-account-cog-outline',
            route: 'settings',
          },
          {
            name: 'Plans & Billing',
            icon: 'mdi-credit-card-settings-outline',
            route: 'billing',
          },
          // {
          //   name: "Sign out",
          //   icon: "mdi-logout",
          // },
          {
            name: 'Admin',
            icon: 'mdi-shield-account-outline',
            route: 'administration',
            upper_divider: true,
            admin_only: true,
            icon_color: '#ccac00',
            // child_routes: [
            //   {
            //     name: "Administration",
            //     icon: "mdi-shield-account-outline",
            //     route: "administration",
            //   },
            // ],
          },
        ],
        drop_down_user_items: [],
        search_input: false,
        image_profile: '',
        image_profile_visible: true,
        crawlo_logo: 'https://image.flaticon.com/icons/svg/331/331395.svg',
        crawlo_logo_name: 'Crawlo',
      },
      base_side_bar_nav_config: {
        routes: [
          {
            name: 'Dashboard',
            header: true,
            route: '/pricing',
            icon: 'dashboard.svg',
            child_routes: [],
          },
          {
            name: 'Analytics',
            header: true,
            route: '/analytics',
            icon: 'compare.svg',
            child_routes: [],
          },
          {
            name: 'Exclusive products',
            header: true,
            route: '/ExclusiveProducts',
            icon: 'exclusive.svg',
            child_routes: [],
          },
          {
            name: 'Favorite products',
            header: true,
            route: '/favoriteProducts',
            icon: 'favorite.svg',
            child_routes: [],
          },
          {
            name: 'Competitors comparison',
            header: true,
            route: '/competitorPriceComparison',
            icon: 'compare2.svg',
            child_routes: [],
          },
          {
            name: 'Add products',
            header: true,
            route: '/importations',
            icon: 'import.svg',
            child_routes: [],
          },
          {
            name: 'My export list',
            header: true,
            route: '/exportations',
            icon: 'export.svg',
            child_routes: [],
          },
          {
            name: 'Alerts',
            header: true,
            route: '/alerts',
            icon: 'alert.svg',
            child_routes: [],
          },
        ],
      },
      authorized_pages: [
        '/subscription',
        '/login',
        '/emailinsert',
        '/resetpassword',
        '/privacy',
        '/termsconditions',
        '/success',
        '/administration',
      ],
    }),
    methods: {
      select_account(account) {
        //select the new account
        this.selected_account = this.associated_accounts.find((acc) => acc.id === account.id) || {
          id: this.account,
          name: 'Current Account',
          region: '',
        }

        //update the localeStorage
        localStorage.setItem('account_id', account.id)
        localStorage.setItem('updateInterval', account.updateInterval)
        localStorage.setItem('account_name', account.name)
        localStorage.setItem('account_company', account.company)
        localStorage.setItem('account_website', account.website.url)
        localStorage.setItem('website_alias', account.website.alias)
        localStorage.setItem('is_similarity_account', account.similarityAccount)
        localStorage.setItem('user_websites', JSON.stringify(account.websites))
        localStorage.setItem('user_website', JSON.stringify(account.website))
        localStorage.setItem('website_url', account.website.url)
        localStorage.setItem('website_color', account.website.config.color)

        //console.log('new account id:', account.id)
        //console.log('new account update interval:', account.updateInterval)
        //console.log('new account is_similarity_account:', account.similarityAccount)
        //console.log('new account websites:', account.websites)
        //console.log('new website alias:', account.website.alias)
        //console.log('new website url:', account.website.url)
        //console.log('new website color:', account.website.config.color)
        //console.log('sacocunt websties : ', account.websites)

        //Reload the app
        window.location.reload()
      },
      loadCurrentPlan() {
        const planId = localStorage.getItem('plan')
        if (planId) {
          // Map plan IDs to readable names based on your subscription system
          const planNames = {
            // Environment variable plan IDs (from subscription component)
            [process.env.VUE_APP_PLAN_BUSINESS?.replace('price_', '')]: 'BUSINESS',
            [process.env.VUE_APP_PLAN_PROFESSIONAL?.replace('price_', '')]: 'PROFESSIONAL',
            [process.env.VUE_APP_PLAN_STARTER?.replace('price_', '')]: 'STARTER',
            [process.env.VUE_APP_PLAN_TRIAL?.replace('price_', '')]: 'TRIAL',
            // Direct plan IDs from Stripe (from plansNames in subscription component)
            '1S66EgKBQj3UOQ3bEs3RPmH9': 'BUSINESS',
            '1S66EIKBQj3UOQ3bYviabrIv': 'PROFESSIONAL',
            '1S66CnKBQj3UOQ3boSv2OPXS': 'STARTER',
            '1SPKvnKBQj3UOQ3bBgyjclMH': 'TRIAL',
            // Full price IDs with prefix
            price_1S66EgKBQj3UOQ3bEs3RPmH9: 'BUSINESS',
            price_1S66EIKBQj3UOQ3bYviabrIv: 'PROFESSIONAL',
            price_1S66CnKBQj3UOQ3boSv2OPXS: 'STARTER',
            price_1SPKvnKBQj3UOQ3bBgyjclMH: 'TRIAL',
            // Index-based mapping from plans component (choosenPlan values)
            0: 'BUSINESS',
            1: 'PROFESSIONAL',
            2: 'STARTER',
            3: 'TRIAL',
            // String versions
            business: 'BUSINESS',
            professional: 'PROFESSIONAL',
            starter: 'STARTER',
            trial: 'TRIAL',
          }

          this.currentPlan = planNames[planId] || `PLAN ${planId}`
        } else {
          this.currentPlan = null
        }
      },
      handleFaviconError(e) {
        // Add error class for styling
        e.target.classList.add('error')
        // Call the global replaceByDefault function
        this.replaceByDefault(e)
      },
      watchLocalStorage() {
        // Watch for changes in localStorage
        window.addEventListener('storage', (e) => {
          if (e.key === 'plan') {
            this.loadCurrentPlan()
          }
        })
      },
      async signOut() {
        if (this.isAuthenticated()) {
          this.destroySocket()
          await this.$store.dispatch('AUTH_LOGOUT')
          // Reset account data
          this.associated_accounts = []
          this.selected_account = {
            region: '',
            name: 'Current Account',
          }
          this.$router.push('/login')
        }
      },
      showNotificationModal(item) {
        this.selected_notification = item
        this.show_notification = !this.show_notification
      },
      async deleteSeenNotification() {
        await axios
          .post(`/api/notification/deleteall`, {
            account: localStorage.getItem('account_id'),
            user: localStorage.getItem('user_id'),
          })
          .then((res) => {
            if (res.data.status) {
              this.showNotification({
                msg: `All seen notifications has been successfully deleted from your notifications list`,
                type: 'success',
                icon: 'delete',
              })
            }
          })
      },
      async deleteNotification(item) {
        await axios
          .post(`/api/notification/delete`, {
            account: localStorage.getItem('account_id'),
            user: localStorage.getItem('user_id'),
            id: item.id,
          })
          .then((res) => {
            if (res.data.status) {
              this.showNotification({
                msg: `The notification has been successfully deleted from your notifications list`,
                type: 'success',
                icon: 'delete',
              })
            }
          })
      },
      destroySocket() {
        try {
          this.$socket.client.emit(
            'DisconnectListening',
            {
              user_id: localStorage.getItem('user_id'),
            },
            (resp) => {
              this.$store.dispatch('socketDestroyed')
            },
          )
        } catch (ex) {
          console.log(ex)
        }
      },
      socketlistener() {
        this.$socket.client.emit(
          'globalListener',
          {
            user_id: localStorage.getItem('user_id'),
          },
          (resp) => {
            this.$store.dispatch('socketConnected')
            this.$socket.client.on('globalListener', (res) => {
              if (res.dataChanged && res.notification) {
                this.showNotification({
                  type: res.data.warning ? 'success' : 'error',
                  msg: res.data.msg,
                })
              }
            })
          },
        )
      },
      redirectTo(route) {
        this.$router.push(route)
      },
      goto() {
        this.$router.push(this.gotoPage)
      },
      logout: function () {
        if (this.isAuthenticated) {
          this.$store.dispatch('AUTH_LOGOUT')
          this.$router.push('/login')
        }
      },
      showNotification(payload) {
        this.snackbar_color = payload.type
        this.snackbar_msg = payload.msg
        this.snackbar_icon = payload.icon
        this.snackbar = !this.snackbar
      },
      getTime(timestamp) {
        let diff = parseInt((Date.now() - timestamp) / 1000)
        let time = ''
        if (diff < 60) time = 'just now'
        else if (diff / 60 < 60) {
          diff = parseInt(diff / 60)
          time = diff == 1 ? 'about a minute ago' : diff + ' minutes ago'
        } else if (diff / 60 / 60 < 24) {
          diff = parseInt(diff / 60 / 60)
          time = diff == 1 ? 'about an hour ago' : diff + ' hours ago'
        } else if (diff / 60 / 60 / 24 < 7) {
          diff = parseInt(diff / 60 / 60 / 24)
          time = diff == 1 ? 'about a day ago' : diff + ' days ago'
        } else {
          diff = parseInt(diff / 60 / 60 / 24 / 7)
          time = diff == 1 ? 'about a week ago' : diff + ' weeks ago'
        }
        return time
      },
      getNotifications() {
        this.notifications = { unseen: [], seen: [] }
        axios
          .get('/api/notification', {
            params: {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
            },
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            this.notifications.seen = res.data.items
              .filter((elt) => elt.viewed)
              .map((elt) => {
                elt.time = this.getTime(elt.timestamp)
                return elt
              })
            this.notifications.unseen = res.data.items
              .filter((elt) => !elt.viewed)
              .map((elt) => {
                elt.time = this.getTime(elt.timestamp)
                return elt
              })
            this.notification_count = this.notifications.unseen.length
          })
          .catch((err) => console.log(err))
      },
      timeoutNotificationTimeAdjustement() {
        setTimeout(() => {
          this.notifications.seen = this.notifications.seen.map((elt) => {
            elt.time = this.getTime(elt.timestamp)
            return elt
          })
          this.notifications.unseen = this.notifications.unseen.map((elt) => {
            elt.time = this.getTime(elt.timestamp)
            return elt
          })
          this.timeoutNotificationTimeAdjustement()
        }, 60000)
      },
      isAuthorized(page) {
        return [
          '/subscription',
          '/login',
          '/emailinsert',
          '/resetpassword',
          '/privacy',
          '/termsconditions',
          '/success',
          '/administration',
        ].includes(page)
      },
      // Version checking methods
      async checkForNewVersion() {
        // Only run in production
        if (process.env.NODE_ENV !== 'production') {
          console.log('[Version Check] Skipping - not in production mode')
          return
        }

        try {
          // Fetch the current index.html with cache-busting
          const response = await fetch(`/index.html?t=${Date.now()}`, {
            cache: 'no-cache',
          })
          const html = await response.text()

          // Extract build hash from meta tag
          const buildHashMatch = html.match(
            /<meta\s+name=["']build-hash["']\s+content=["']([^"']+)["']/,
          )

          if (buildHashMatch && buildHashMatch[1]) {
            const newBuildHash = buildHashMatch[1]

            console.log('[Version Check] Current hash:', this.currentBuildHash)
            console.log('[Version Check] New hash:', newBuildHash)

            // Compare with current version
            if (this.currentBuildHash && newBuildHash !== this.currentBuildHash) {
              // New version detected!
              console.log('[Version Check] New version detected! Showing dialog.')
              this.showRefreshDialog = true
              // Stop checking once new version is found
              this.stopVersionCheck()
            } else {
              console.log('[Version Check] No update detected')
            }
          } else {
            console.warn('[Version Check] Could not find build-hash meta tag')
          }
        } catch (error) {
          console.error('[Version Check] Failed:', error)
        }
      },
      startVersionCheck() {
        // Only run in production
        if (process.env.NODE_ENV !== 'production') {
          console.log('[Version Check] Disabled - not in production mode')
          return
        }

        console.log('[Version Check] Starting version checker...')
        console.log('[Version Check] Initial build hash:', this.currentBuildHash)

        // Check every 5 minutes (300000 ms)
        this.versionCheckInterval = setInterval(() => {
          console.log('[Version Check] Running periodic check...')
          this.checkForNewVersion()
        }, 300000)

        // Do an immediate check after 10 seconds for testing
        setTimeout(() => {
          console.log('[Version Check] Running initial check...')
          this.checkForNewVersion()
        }, 10000)
      },
      stopVersionCheck() {
        if (this.versionCheckInterval) {
          clearInterval(this.versionCheckInterval)
          this.versionCheckInterval = null
        }
      },
      refreshPage() {
        window.location.reload(true)
      },
      dismissRefreshDialog() {
        this.showRefreshDialog = false
        // Check again in 10 minutes if dismissed
        setTimeout(() => {
          this.checkForNewVersion()
        }, 600000)
      },
    },
    created() {
      if (this.$socket == undefined && !this.isAuthorized(this.$route.path.toLowerCase())) {
        this.getNotifications()
        this.connectSocket()
        this.socketlistener()
        this.timeoutNotificationTimeAdjustement()
        this.$socket.client.on('globalListener', (data) => {
          if (data.dataChanged && data.cause == 'notificationChanges') {
            this.getNotifications()
          }
        })
      }
    },
    mounted() {
      // Initialize plan badge
      this.loadCurrentPlan()
      this.watchLocalStorage()
      this.associated_accounts = localStorage.associated_accounts
        ? JSON.parse(localStorage.associated_accounts)
        : []

      console.log('this.account', this.account)

      this.selected_account = this.associated_accounts.find((acc) => acc.id === this.account) || {
        id: this.account,
        name: 'Current Account',
        region: '',
      }

      console.log('selected_account', this.selected_account)

      /**
       * We will back to this later
       */
      // this.$socket.client.on("connect", () => {
      //   console.log("socket connected");
      // });

      // this.$socket.client.on("disconnect", () => {
      //   const connectionRetries = setInterval(() => {
      //     console.log("reconnecting");
      //     if (this.$socket.client.connected) {
      //       clearInterval(connectionRetries);
      //       this.socketlistener();
      //     }
      //   }, 1000);
      // });

      // this.nav_bar_config.drop_down_items[2].callback = this.signOut();
      document.getElementById('index-loading').remove()
      let zendesk = document.createElement('script')
      zendesk.setAttribute(
        'src',
        'https://static.zdassets.com/ekr/snippet.js?key=07830ac3-e4b2-48fa-a70c-ed3cdddbae73',
      )
      zendesk.setAttribute('id', 'ze-snippet')
      //document.head.appendChild(zendesk)
      axios.interceptors.request.use((request) => {
        this.$Progress.start()
        return request
      })

      document.title = 'Dynamic Pricing'

      axios.interceptors.response.use(
        (response) => {
          this.$Progress.finish()
          return response
        },
        (error) => {
          this.$Progress.fail()
        },
      )

      // Start version checking (production only)
      this.startVersionCheck()
    },
    computed: {
      isViewer() {
        return this.$store.getters.userRole === 'viewer'
      },
      side_bar_nav_config() {
        return this.base_side_bar_nav_config
      },
      isAuthenticated() {
        return this.$store.getters.isAuthenticated
      },
      avatar_text() {
        let avatar = this.fullname != undefined ? this.fullname.trim().split(' ') : []
        avatar = (avatar.length > 0 ? avatar[0][0] : '') + (avatar.length > 1 ? avatar[1][0] : '')
        return avatar.toUpperCase()
      },
      faviconSrc() {
        if (this.account == '654b792b2071861acbbc3331') {
          return require('./assets/favicon_1.png')
        }

        const website = this.user_website?.id == this.source_id ? 'www.mi.com' : this.website_url
        if (!website || website.trim() === '') {
          return require('./assets/favicon_1.png')
        }

        return `https://8181.integ.crawlo.com/favicon?size=xs&website=${website}`
      },
      faviconAlt() {
        if (this.account == '654b792b2071861acbbc3331') {
          return 'Default favicon'
        }
        return this.user_website?.id == this.source_id ? 'www.mi.com' : this.website_alias
      },
    },

    watch: {
      async $route(to, from) {
        this.selected_item = to.path.toLowerCase()

        if (this.$socket == undefined && !this.isAuthorized(to.path.toLowerCase())) {
          this.connectSocket()
          this.socketlistener()
        }

        if (from.path.toLowerCase() == '/login' && !this.isAuthorized(to.path.toLowerCase())) {
          // Update account ID from localStorage (in case user logged in with different account)
          this.account = localStorage.getItem('account_id')
          this.fullname = localStorage.getItem('fullname')
          this.username = localStorage.getItem('user')
          this.website_alias = localStorage.getItem('website_alias')
          this.website_url = localStorage.getItem('website_url')
          this.website_color = localStorage.getItem('website_color')
          this.super_admin = localStorage.getItem('super_admin')
          this.associated_accounts = localStorage.associated_accounts
            ? JSON.parse(localStorage.associated_accounts)
            : []
          this.selected_account = this.associated_accounts.find(
            (acc) => acc.id === this.account,
          ) || {
            id: this.account,
            name: 'Current Account',
            region: '',
          }
          this.navBarKey = Date.now()
          this.getNotifications()
        }

        if (this.website_alias != localStorage.getItem('website_alias')) {
          this.website_alias = localStorage.getItem('website_alias')
          this.website_url = localStorage.getItem('website_url')
          this.website_color = localStorage.getItem('website_color')
        }
      },
    },
  }
</script>

<style lang="less">
  .v-application,
  .v-data-iterator,
  .v-data-table-header {
    font-family: 'Red Hat Display', sans-serif !important;
  }

  .sm-text {
    font-size: 0.8em !important;
  }
  .md-text {
    font-size: 1.2em !important;
  }
  .lg-text {
    font-size: 1.6em !important;
  }
  .xl-text {
    font-size: 2em !important;
  }
  .xxl-text {
    font-size: 2em !important;
  }

  a {
    text-decoration: none;
  }
</style>

<style>
  /*.content-background {
    background-color: #f8f8f8;
  }*/
  .text-danger {
    color: #bc3343;
  }
  .text-success {
    color: #42b983;
  }
  .text-small {
    font-size: 0.8rem;
  }
  .mw-100 {
    max-width: 100% !important;
  }
  .w-100 {
    width: 100% !important;
  }
  .w-90 {
    width: 90% !important;
  }
  .w-80 {
    width: 80% !important;
  }
  .w-70 {
    width: 70% !important;
  }
  .w-60 {
    width: 60% !important;
  }
  .w-50 {
    width: 50% !important;
  }
  .w-40 {
    width: 40% !important;
  }
  .w-30 {
    width: 30% !important;
  }
  .w-25 {
    width: 25% !important;
  }
  .w-20 {
    width: 20% !important;
  }
  .w-15 {
    width: 15% !important;
  }
  .w-10 {
    width: 10% !important;
  }
  .w-0 {
    width: 0% !important;
  }
  .favicon-img {
    border-radius: 5px;
    background-color: #f5f5f5;
    transition: opacity 0.3s ease;
  }
  .favicon-img:hover {
    opacity: 0.8;
  }
  .favicon-img.error {
    background-color: #e0e0e0;
    opacity: 0.7;
  }
  .favicon-img.placeholder-image {
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    opacity: 0.8;
  }
  .product-image {
    height: 80px;
    background-size: cover;
    margin: 10px 0px;
  }
  .simple-table-row-height {
    height: 55px;
  }

  .v-data-table td,
  .v-data-table th,
  .v-data-iterator .v-list {
    font-size: 1rem !important;
  }
  .v-data-iterator .v-card__title,
  .v-data-table th {
    font-weight: 900 !important;
  }
  .v-data-iterator .v-card__title {
    font-size: 1.4rem !important;
  }
  .cursor-pointer {
    cursor: pointer !important;
  }

  .not_found_product {
    background: #ffd2d2 !important;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(70, 76, 91, 0.8);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(70, 76, 91, 1);
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(70, 76, 91, 0.6);
  }

  .v-data-table__wrapper > table > tbody > tr:hover {
    background: inherit !important;
  }
  .mainNavBar {
    box-shadow: none !important;
  }
  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: none;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  /* Version Update Dialog */
  .version-dialog-card {
    overflow: hidden;
    border: none !important;
  }
  .version-accent-strip {
    height: 4px;
    background: linear-gradient(90deg, #ff8c00, #ffa940, #ff8c00);
  }
  .version-icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff8c00, #ffa940);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(255, 140, 0, 0.3);
  }
  .version-info-box {
    background: #fff8f0;
    border: 1px solid #ffe0b2;
  }

  /* Plan Badge Styling */
  .plan-badge {
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 1px solid rgba(255, 255, 255, 0.7) !important;
  }

  .plan-badge:hover {
    border-color: white !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  /* Responsive design for mobile */
  @media (max-width: 599px) {
    .plan-badge {
      font-size: 10px !important;
      height: 24px !important;
    }

    .plan-badge .v-chip__content {
      padding: 0 8px !important;
    }
  }
</style>
